import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { WorkingTimeModelFiltersDto } from '@/generated/Messages/Filters_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import {
    listQueryKeyPrefix,
    workingTimeModelsQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

export const workingTimeModelsListQueryKeyPrefix = [
    workingTimeModelsQueryKeyPrefix,
    listQueryKeyPrefix,
] as const

export const workingTimeModelsQueryOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    filter: Partial<OmitDeepMessageFields<WorkingTimeModelFiltersDto>> = {}
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...workingTimeModelsListQueryKeyPrefix, filter],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.workingTimeModel)

            const response =
                await clients.workingTimeModel.getWorkingTimeModels(
                    {
                        deletedItemSelection:
                            filter.deletedItemSelection ??
                            DeletedItemSelection.BOTH,
                        ids: filter.ids ?? [],
                        sorting: filter.sorting ?? [],
                        pagination: filter.pagination,
                        searching: filter.searching ?? [],
                        searchOperator: filter.searchOperator,
                        userIds: filter.ids ?? [],
                    },
                    { signal }
                )

            return response
        },
    })

export const useWorkingTimeModels = (
    filter: Partial<OmitDeepMessageFields<WorkingTimeModelFiltersDto>> = {}
) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(workingTimeModelsQueryOptions(clients, filter))
}
